import { ICON_TYPES } from '../constants';

export const ArtServiceOne = (): JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="78.543"
      height="89.217"
      viewBox="0 0 78.543 89.217"
    >
      <g
        id="Group_1"
        data-name="Group 1"
        transform="translate(-338.726 -622.771)"
      >
        <path
          id="Path_9"
          data-name="Path 9"
          d="M4.926,52.363H82.068"
          transform="translate(334.5 620)"
          fill="none"
          stroke="#143639"
          strokeLinecap="round"
          stroke-miterlimit="10"
          strokeWidth="1.4"
        />
        <path
          id="Path_10"
          data-name="Path 10"
          d="M9.73,88.688s11.295-5.83,8.89-17.982c-1.455-7.358-3.132-11.106-4.226-12.917a3.347,3.347,0,0,1,2.03-4.979.657.657,0,0,1,.1-.021c3.243-.727,8.052,7.41,10.452,10.994s6.247,9.9,8.954,9.781,22.951-15.185,26.858-17.19,6.188-3.1,8.409-3.158a2.567,2.567,0,0,1,1.864,4.372c-1.681,1.639-5.345,3.524-13.218,10.693S36.23,91,36.23,91"
          transform="translate(334.5 620)"
          fill="none"
          stroke="#143639"
          strokeLinecap="round"
          stroke-miterlimit="10"
          strokeWidth="1.4"
        />
        <path
          id="Path_11"
          data-name="Path 11"
          d="M50.949,76.656s24.7-16.033,26.2-17.126,3-3.158,1.741-5.164-4.077-.934-5.7-.254"
          transform="translate(334.5 620)"
          fill="none"
          stroke="#143639"
          strokeLinecap="round"
          stroke-miterlimit="10"
          strokeWidth="1.4"
        />
        <path
          id="Path_12"
          data-name="Path 12"
          d="M35.074,73.41S46.739,55.944,50.586,53.392s6.43,1.4,5.349,3.223-2.528,3.094-5.949,8.318"
          transform="translate(334.5 620)"
          fill="none"
          stroke="#143639"
          strokeLinecap="round"
          stroke-miterlimit="10"
          strokeWidth="1.4"
        />
        <path
          id="Path_13"
          data-name="Path 13"
          d="M23.793,13.531H63.2V47.546a4.844,4.844,0,0,1-4.813,4.867H28.606a4.844,4.844,0,0,1-4.813-4.867Z"
          transform="translate(334.5 620)"
          fill="none"
          stroke="#143639"
          strokeLinecap="round"
          stroke-miterlimit="10"
          strokeWidth="1.4"
        />
        <path
          id="Path_14"
          data-name="Path 14"
          d="M57.828,25.446a20.274,20.274,0,0,0,5.243-2.719"
          transform="translate(334.5 620)"
          fill="none"
          stroke="#143639"
          strokeLinecap="round"
          stroke-miterlimit="10"
          strokeWidth="1.4"
        />
        <path
          id="Path_15"
          data-name="Path 15"
          d="M23.8,26.222s7.928-6.162,19.7-1.39c.515.211,1.026.4,1.528.564"
          transform="translate(334.5 620)"
          fill="none"
          stroke="#143639"
          strokeLinecap="round"
          stroke-miterlimit="10"
          strokeWidth="1.4"
        />
        <path
          id="Path_16"
          data-name="Path 16"
          d="M57.829,25.44,51.371,18.91,44.913,25.44l6.458,6.53Z"
          transform="translate(334.5 620)"
          fill="none"
          stroke="#143639"
          strokeLinecap="round"
          stroke-miterlimit="10"
          strokeWidth="1.4"
        />
        <path
          id="Path_17"
          data-name="Path 17"
          d="M44.13,38.869l-6.458-6.53-6.458,6.53,6.458,6.53Z"
          transform="translate(334.5 620)"
          fill="none"
          stroke="#143639"
          strokeLinecap="round"
          stroke-miterlimit="10"
          strokeWidth="1.4"
        />
        <path
          id="Path_18"
          data-name="Path 18"
          d="M17.186,6.015a9.314,9.314,0,0,1,13.256.473l.049.054L16.768,19.472l-.049-.054A9.565,9.565,0,0,1,17.186,6.015Z"
          transform="translate(334.5 620)"
          fill="none"
          stroke="#143639"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="1.4"
        />
      </g>
    </svg>
  );
};

ArtServiceOne.iconType = ICON_TYPES.ART_SERVICE_ONE;
